const soleoSiret = '82220698300030';
export default soleoSiret;
